const benefits = [
  {
    icon: 'ri-check-double-line',
    title: 'Prodotti selezionati',
    desc: 'Trova articoli organizzati per categoria con informazioni complete e verificate per ogni prodotto.',
  },
  {
    icon: 'ri-camera-line',
    title: 'Foto QC',
    desc: 'Controlla meglio qualit\u00e0 e dettagli attraverso immagini QC reali prima di finalizzare l\u2019acquisto.',
  },
  {
    icon: 'ri-timer-flash-line',
    title: 'Risparmio di tempo',
    desc: 'Evita lunghe ricerche manuali: tutto \u00e8 gi\u00e0 organizzato per categoria e pronto da consultare.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Acquisti pi\u00f9 sicuri',
    desc: 'Segui procedure consigliate e verifica ogni dettaglio per acquistare con maggiore tranquillit\u00e0.',
  },
];

export default function BenefitsSection() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 lg:px-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-medium text-primary-600 uppercase tracking-widest mb-3">
            Vantaggi
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Perch&eacute; utilizzare Itaobuy Spreadsheet?
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Scopri i vantaggi di utilizzare il nostro database per i tuoi acquisti
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {benefits.map((b) => (
            <div key={b.title} className="group p-6 md:p-8 rounded-2xl bg-background-100 hover:bg-primary-50 transition-colors duration-300">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-200 transition-colors">
                <i className={`${b.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-lg text-foreground-900 mb-2.5">
                {b.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                {b.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}